const STABLE_MESSAGES = {
    closed: 'Local storage is closed. Reload the app and try again.',
    conflict: 'This item changed in another operation. Reload it and try again.',
    'integrity-failed': 'The local data failed an integrity check. Use a known-good export.',
    'invalid-data': 'The data is not a valid tchoma storage dataset.',
    'limit-exceeded': 'This operation is too large for the local storage safety limit.',
    'migration-failed': 'The storage update failed. Your previous data remains available.',
    'quota-exceeded': 'Local storage is full. Export or remove media, then try again.',
    'transaction-failed': 'The local change could not be saved. No partial document change was kept.',
    unsupported: 'This browser does not support the required local storage feature.',
};
export class StorageError extends Error {
    code;
    recoverable;
    userMessage;
    cause;
    constructor(code, options) {
        super(options?.detail ?? STABLE_MESSAGES[code]);
        this.name = 'StorageError';
        this.code = code;
        this.recoverable = options?.recoverable ?? true;
        this.userMessage = STABLE_MESSAGES[code];
        this.cause = options?.cause;
    }
}
export function isQuotaError(error) {
    if (error instanceof StorageError)
        return error.code === 'quota-exceeded';
    if (typeof DOMException === 'undefined' || !(error instanceof DOMException))
        return false;
    return error.name === 'QuotaExceededError' || error.name === 'NS_ERROR_DOM_QUOTA_REACHED';
}
export function mapStorageError(error, fallback = 'transaction-failed') {
    if (error instanceof StorageError)
        return error;
    if (isQuotaError(error))
        return new StorageError('quota-exceeded', { cause: error });
    return new StorageError(fallback, { cause: error });
}
//# sourceMappingURL=errors.js.map